
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShiftPresetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShiftPreset"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsAtTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endsAtTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shiftEvaluationTagIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breakTime"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":164}};
    doc.loc.source = {"body":"fragment ShiftPresetFragment on ShiftPreset {\n  id\n  color\n  name\n  shortName\n  startsAt\n  startsAtTime\n  endsAtTime\n  tagIds\n  shiftEvaluationTagIds\n  breakTime\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
